import React from "react";
import DashboardWelcome from "@/components/dashboard/DashboardWelcome";
import DashboardNotificationStats from "@/components/dashboard/DashboardNotificationStats";
import DashboardRecentNotifications from "@/components/dashboard/DashboardRecentNotifications";
import DashboardTeamActivity from "@/components/dashboard/DashboardTeamActivity";
import { useIsMobile } from "@/hooks/use-mobile";

const Dashboard = () => {
  const isMobile = useIsMobile();
  return (
    <div className={isMobile ? "space-y-3" : "space-y-6"}>
      <DashboardWelcome />

      <DashboardNotificationStats />

      <div className="grid gap-6 lg:grid-cols-2">
        <DashboardRecentNotifications />
        <DashboardTeamActivity />
      </div>
    </div>
  );
};

export default Dashboard;
